// src/components/MobileMenu.js

import React, { useEffect, useRef, useState } from 'react';
import { AsideLeft } from '../../aside-left';

const MobileMenu = () => {
  const menuRef = useRef<HTMLDivElement | null>(null); // Add this in the component
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false); // Close menu
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div>
      {/* Hamburger Icon */}
      <button className="block xl:hidden p-2 text-gray-800 dark:text-white z-50 relative" onClick={toggleMenu} aria-label="Toggle Menu">
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
      </button>

      {/* Sliding Menu */}
      <div
        ref={menuRef}
        className={`fixed top-0 right-0 h-screen w-2/3 max-w-sm bg-white dark:bg-dark2 shadow-xl z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close Button */}
        <button className="absolute top-4 right-4 p-2 text-gray-800 z-50" onClick={toggleMenu} aria-label="Close Menu">
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        {/* Menu Items */}
        <AsideLeft isMobile />
      </div>

      {/* Overlay (optional, for dimming background) */}
      {isOpen && <div className="fixed inset-0 z-40" onClick={toggleMenu} />}
    </div>
  );
};

export default MobileMenu;
